<template>
  <Landing></Landing>
</template>

<script>
// @ is an alias to /src
import Landing from '@/components/Landing.vue'

export default {
  name: 'LandingView',
  components: {
    Landing
  }
}
</script>
